// Global fetch override to prevent tldraw translation errors
// This should be imported early in the application lifecycle
let originalFetch;
export const setupFetchOverride = () => {
    if (typeof originalFetch === 'function') {
        return; // Already set up
    }
    originalFetch = window.fetch;
    window.fetch = async (input, init) => {
        // Guard against fetch(undefined|null) — callers passing undefined produced
        // "Cannot read properties of undefined (reading 'url')" before this check.
        // Let the original fetch handle the invalid input so the error surfaces
        // from the Fetch API itself with a meaningful message.
        if (input == null) {
            return originalFetch(input, init);
        }
        const url = typeof input === 'string'
            ? input
            : input instanceof URL
                ? input.href
                : typeof input.url === 'string'
                    ? input.url
                    : '';
        // Skip WebSocket URLs - they don't use Fetch API
        if (url && (url.startsWith('ws://') || url.startsWith('wss://'))) {
            return originalFetch(input, init);
        }
        // Block tldraw translation requests and specific external requests, but allow Supabase
        if (url && (url.includes('translation') ||
            url.includes('tldraw') ||
            url.includes('unpkg.com') ||
            url.includes('cdn.') ||
            url.includes('jsdelivr.net') ||
            url.includes('skypack.dev') ||
            url.includes('esm.sh') ||
            (url.startsWith('https://') &&
                !url.includes(window.location.hostname) &&
                !url.includes('supabase.co') &&
                !url.includes('api.mypace.app') &&
                !url.includes('mypace.app') &&
                !url.includes('stripe.com') &&
                !url.includes('paypal.com') &&
                !url.includes('googleapis.com') &&
                !url.includes('sentry.io') &&
                !url.includes('fonts.gstatic.com')))) {
            return new Response(JSON.stringify({}), {
                status: 200,
                statusText: 'OK',
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            });
        }
        return originalFetch(input, init);
    };
};
export const restoreFetch = () => {
    if (originalFetch) {
        window.fetch = originalFetch;
        originalFetch = null;
    }
};
// Auto-setup when this module is imported
if (typeof window !== 'undefined') {
    setupFetchOverride();
}
